import React from "react";
import { RatingSummary } from "@interfaces/dto/review.dto";
import RatingStars from "@components/features/product-detail/info/Ratings";
import { ProductDetail } from "@interfaces/dto/product-detail.dto";
import { calculateStarRating } from "@utils/starRate";

interface Props {
  productDetail: ProductDetail;
  totalReviews: number;
  reviewSummary: RatingSummary[];
}
const ReviewRate = ({ productDetail, totalReviews, reviewSummary }: Props) => {
  const { starAverage, starText } = calculateStarRating({reviewSummary, totalReviews});

  return (
    <>
      <div className="col-6 col-sm-4 review-rating">
        <b>คะแนนเฉลี่ย</b>
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column">
            <big>
              {starAverage.toFixed(1)} <p className="text">{starText}</p>{" "}
            </big>
            <div className="d-flex flex-wrap">
              <RatingStars starCount={productDetail.review[0].star_rating} />
              <span className="num-review">{productDetail.review[0].reviews_count} รีวิว</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewRate;
